import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import { primaryColor } from '../theme'

const LoadingPage = ({ loadingText }) => (
    <div className="loading">
        <CircularProgress size={80} thickness={5} color={primaryColor} />
        <p style={{ paddingTop: 20 }}>{loadingText}</p>
    </div>
);

export default LoadingPage;